var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInputBarVoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-input-bar-voice",
    transform: "translate(-366 -301)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5673",
    "data-name": "Rectangle 5673",
    width: 29,
    height: 30,
    transform: "translate(366 301)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_61",
    "data-name": "Group 61",
    transform: "translate(371.343 303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_63",
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M17.59,19.208h0a5.132,5.132,0,0,1-5.132-5.132V6.132a5.132,5.132,0,0,1,10.265,0v7.943A5.132,5.132,0,0,1,17.59,19.208Z",
    transform: "translate(-8.257 -1)",
    fill: "none",
    stroke: "#2f215f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M19.666,33.417v1.146A9.333,9.333,0,0,1,1,34.563V33.417",
    transform: "translate(-1 -21.533)",
    fill: "none",
    stroke: "#2f215f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    y2: 4.094,
    transform: "translate(9.333 22.363)",
    fill: "none",
    stroke: "#2f215f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    x1: 6.416,
    transform: "translate(6.125 26.456)",
    fill: "none",
    stroke: "#2f215f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInputBarVoice);
export default __webpack_public_path__ + "static/media/icon-input-bar-voice.79c16e44c313f0df4164a9e933b47db2.svg";
export { ForwardRef as ReactComponent };